{
  "it": {
    "contact": {
      "actions": {
        "accept": "Ok",
        "add": "Aggiungi contatto",
        "add_type": "Aggiungi {type}",
        "backInspirationLists": "Torna agli elenchi di ispirazione",
        "cancelNew": "Annulla",
        "deactivateEmployee": "Disattiva",
        "deleteCustomer": "Elimina cliente...",
        "deleteEmployee": "Elimina membro del team...",
        "deleteLead": "Elimina lead...",
        "deletePartner": "Elimina partner...",
        "delete_contact": "Elimina",
        "edit": "Modifica",
        "impersonate": "Impersona",
        "impersonateStart": "Attraversi il portale arancione per esplorare il mondo di {name}.",
        "impersonateStop": "Torna al Suo mondo",
        "invite": "Invia invito",
        "newTicket": "Nuova conversazione",
        "reactivateEmployee": "Riattiva",
        "resendInvitationEmail": "Reinvia email di invito",
        "searchContact": "Cerca contatto",
        "searchCustomer": "Cerca cliente",
        "searchEmployee": "Cerca membro del team",
        "selectAll": "Seleziona tutti i {total} contatti",
        "selectOption": "Selezioni un'opzione",
        "setProfilePicture": "Imposta immagine del profilo",
        "showall": "Mostra tutti",
        "unSelectAll": "Svuota selezione."
      },
      "attributes": {
        "language": "Lingua",
        "timezone": "Fuso orario",
        "title": "Titolo"
      },
      "labels": {
        "address": "Indirizzo",
        "all": "Tutti i contatti",
        "back_to_overview": "Torna alla panoramica",
        "cannot_create_role": "Contatti un proprietario per creare un nuovo contatto",
        "cannot_delete": "Impossibile eliminare questo utente (integrazione)",
        "company": "Organizzazione",
        "company_all": "Tutte le organizzazioni",
        "contact_status": {
          "active": "Attivo",
          "added": "Non ancora invitato",
          "all": "Tutti gli stati",
          "blocked": "Disattivato",
          "invited": "Invitato",
          "status": "Stato"
        },
        "contact_type": "Tipo",
        "customer": "Cliente",
        "customers": "Clienti",
        "employee": "Team",
        "export_contacts": "Esporta contatti",
        "general": "Generale",
        "impersonateInactiveProfile": "Questa fantastica persona non è ancora attiva. Attivi prima il cliente.",
        "invite": "Sì, invita i contatti",
        "inviteProfileFirstCustomer": "Inviti prima il cliente sulla piattaforma per poter inviare un messaggio, impersonarlo o inviare di nuovo l'email di invito",
        "inviteProfileFirstPartner": "Inviti prima il partner sulla piattaforma per poter impersonarlo o inviare di nuovo l'email di invito",
        "last_login": "Ultimo accesso",
        "last_seen": "ultima visita",
        "last_seen_not_seen_yet": "nessun accesso ancora",
        "lead": "Lead",
        "name": "Nome",
        "name_or_email_address": "Nome o indirizzo email",
        "name_or_email_address_phone": "Nome, indirizzo email o telefono",
        "noContacts": "Nessun contatto",
        "no_contacts": "Nessun contatto da esportare",
        "no_contacts_results": "Questa ricerca non ha prodotto risultati. Provi altri filtri per trovare la persona giusta.",
        "no_contacts_results_subtitle": "Questa ricerca non ha prodotto risultati. Provi altri filtri per trovare la persona giusta.",
        "no_contacts_results_title": "Nessun contatto trovato",
        "number_contacts": "Nessun contatto | 1 contatto | {count} contatti",
        "other": "Altro",
        "partner": "Partner",
        "partners": "Partner",
        "project": "Progetto",
        "secondary_contact": "Contatto secondario",
        "selectOne": "Selezioni almeno 1 contatto",
        "selectProjectForImpersonation": "Per quale progetto desidera impersonare {customer_name}?",
        "selected": "{selected} contatto selezionato. | {selected} contatti selezionati.",
        "sorting": {
          "last_name": "Nome",
          "session_started_at": "Ultimo accesso",
          "status": "Stato"
        },
        "totalSelected": "Tutti i {total} contatti sono selezionati.",
        "units": "Unità"
      },
      "navigation": {
        "backToContacts": "Torna ai contatti"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Per nome o indirizzo email"
      },
      "validation": {
        "emailTaken": "L'indirizzo email è uguale a quello precedente",
        "mustBeEmailAddress": "È richiesto un indirizzo email valido",
        "requireEmailAddress": "Email obbligatoria"
      }
    }
  }
}
